var index;

module.exports = index = {
  matrix: require("./matrix"),
  lu: require("./lu"),
  ud: require("./ud")
};

if (typeof window !== "undefined" && window !== null) {
  window.m4th = index;
}
